<template>
	<div>
		<div class="title">尊敬的马帮用户，请联系专属顾问进行充值，谢谢!</div>
		<!-- <div>
			<div class="mb-tabs">
				<el-tabs v-model="activeTitle" @tab-click="checkTab">
					<div></div>
					<el-tab-pane v-for="(tab, idx) in tabsList" :key="idx" :name="tab.id + ''">
						<template slot="label">
							<el-tooltip
								:content="tab.describe"
								placement="bottom"
								effect="light"
								popper-class="tooltip_class"
								:visible-arrow="false"
							>
								<div>
									<div class="label-img">
										<img :src="tab.img" />
									</div>
									<div class="label-title">{{ tab.name }}</div>

									<div class="label-font">{{ tab.describe }}</div>
								</div>
							</el-tooltip>
						</template>
					</el-tab-pane>
				</el-tabs>
			</div>
			<mbCarousel :cardList="cardList" :totalPrice="totalPrice" @mb-check-card="checkCard" @mb-buy-btn="buyBtn">
				<div slot="buyOption">
					<div>
						<div class="inline-block-div">
							<div class="text-height" v-if="childCheckCardData.attribute">选择购买平台：</div>
							<div class="text-height">购买{{ childCheckCardData.name }}加购包数：</div>
						</div>
						<div class="inline-block-div">
							<div class="text-between" v-if="childCheckCardData.attribute">
								<el-radio-group v-model="radioLabelId" size="medium">
									<el-radio
										:label="btn.id"
										border
										v-for="(btn, idx) in childCheckCardData.attribute"
										:key="idx"
									>
										{{ btn.platform }}
									</el-radio>
								</el-radio-group>
							</div>
							<div class="text-between">
								<span>
									<el-input-number
										v-model="packgeCount"
										@change="changeCount"
										:min="1"
										:max="100"
										size="small"
									></el-input-number>
									个
								</span>
								<span class="ml20">共计：{{ packgeCount }} 个</span>
							</div>
						</div>
					</div>
				</div>
			</mbCarousel>
		</div> -->
	</div>
</template>

<script>
import { editions } from '@/utils/api'
// import mbCarousel from '@/components/mb-carousel'
// import Constant from '@/utils/constant'
import { mabangPay } from '@/utils/constant'

export default {
	components: {
		// mbCarousel,
	},
	data() {
		return {
			/**
			 * dev 开发专业版 需要选择加购包平台
			 */
			projectId: null,
			tabsList: [],
			cardList: [],
			activeTitle: null,
			totalPrice: 0,
			childCheckCardData: {},
			packgeCount: 1,
			radioLabelId: 0,
			devOption: false, // 删除该字段使用childCheckCardData.attribute判断是否显示选择平台
		}
	},
	watch: {
		// ProjectId: {
		// 	handler(newStr) {
		// 		if (newStr === Constant.PROJECT_ID_DEV) {
		// 			this.devOption = true
		// 		}
		// 	},
		// 	immediate: true,
		// },
	},
	mounted() {
		if (JSON.parse(sessionStorage.getItem('sourceInfo'))) {
			this.projectId = JSON.parse(sessionStorage.getItem('sourceInfo')).projectId
		}
		this.getTabs()
	},
	methods: {
		getTabs() {
			let params = {
				moduleId: JSON.parse(sessionStorage.getItem('projectInfo')).id,
				source: JSON.parse(sessionStorage.getItem('sourceInfo')).sourceId,
			}
			editions(params).then((res) => {
				let ary = res.filter((item) => {
					return item.project.indexOf(this.projectId) > -1
				})
				this.tabsList = [...ary]

				if (this.$route.query.editionId) {
					this.activeTitle = this.$route.query.editionId + ''
					this.tabsList.forEach((item) => {
						if (item.id == this.$route.query.editionId) {
							this.cardList = item.list
						}
					})
				} else {
					this.activeTitle = this.tabsList[0].id + ''
					this.cardList = [...ary[0].list]
				}
			})
		},
		checkTab() {
			let obj = this.tabsList.filter((item) => item.id == this.activeTitle)
			// if(obj[0].list.length == 0) {
			// 	this.cardList.length = [];
			// } else {
			// 	}
			this.cardList = [...obj[0].list]
			this.calcTotalPrice()
		},
		checkCard(card) {
			this.childCheckCardData = card
			if (this.childCheckCardData.attribute) {
				this.radioLabelId = this.childCheckCardData.attribute[0].id
			}
			this.calcTotalPrice()
		},
		calcTotalPrice() {
			this.totalPrice = this.packgeCount * this.childCheckCardData.price
		},
		buyBtn() {
			let attributeId = null
			if (this.childCheckCardData.attribute) {
				//开发专业版不同平台的商品id
				attributeId = this.radioLabelId
			}
			let params = {
				goodsId: this.childCheckCardData.id,
				buyNum: this.packgeCount,
				attributeId: attributeId,
				moduleId: JSON.parse(sessionStorage.getItem('projectInfo')).id,
			}
			mabangPay(params)
		},
		changeCount() {
			this.calcTotalPrice()
		},
	},
}
</script>

<style scoped>
.title {
	color: red;
	text-align: center;
	font-weight: bold;
	margin-top: 20px;
}
.el-carousel__item h3 {
	color: black;
	font-size: 18px;
	opacity: 0.75;
	line-height: 300px;
	margin: 0;
}

/* .shop-card {
	width: 380px;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
} */
/* .bg1 {
	background: url('../../assets/images/bg1.png') no-repeat 0 0;
	background-size: 100% 100%;
	color: black;
} */

/* .bg2 {
	background: url('../../assets/images/bg2.png') no-repeat 0 0;
	background-size: 100% 100%;
	color: #e9bd9c;
} */
.ml20 {
	margin-left: 20px;
}
/* .div-border {
	padding-top: 10px;
	border-bottom: 1px solid #ccc;
} */
/* .buy {
	display: flex;
	justify-content: space-between;
	align-items: baseline;
} */
.text-between {
	text-align: justify;
	height: 50px;
	line-height: 50px;
}
.text-between > i {
	display: inline-block /* Opera */;
	padding-left: 100%;
}
.text-height {
	height: 50px;
	line-height: 50px;
	text-align: right;
}
</style>
